import _ from "lodash";
import React from "react";
import classes from "./MediaUploadButton.scss";
import { connect } from "react-redux";

import {
  onCreateQuestionAttachment,
  getDropDownOptions,
} from "Worksheet/modules/WorksheetUtils";
import { CreateDropDown } from "Attachment";
import { Button } from "@toddle-edu/ds-web";
import { AddOutlined } from "@toddle-edu/ds-icons";
import { createAttachment } from "modules/Services";

const style = {
  createDropDownContainerStyle: {
    top: 48,
    zIndex: 1001,
  },
};

const MediaUploadButton = React.memo(props => {
  const {
    currentFields,
    createAttachment,
    isUploading,
    t,
    updateInputField,
    isWorksheetWebView,
  } = props;

  const resourceFieldData = _.find(
    currentFields,
    field => field.uid === "resources"
  );

  const dropDownOptions = getDropDownOptions(isWorksheetWebView);

  const onCreateAttachment = async ({ attachments }) => {
    const parentType = "QUESTION_SUBMISSION_ATTACHMENT";

    await onCreateQuestionAttachment({
      attachments,
      field: resourceFieldData,
      createAttachment,
      parentType,
    });
    updateInputField({}); // To update attempted question logic in cache
  };

  return (
    <div className={classes.createDropdownContainer}>
      <CreateDropDown
        dropDownOptions={dropDownOptions}
        parentId={resourceFieldData?.id}
        parentType={"QUESTION_SUBMISSION_ATTACHMENT"}
        isCreateDropDownDisabled={isUploading}
        buttonComponent={
          <Button
            icon={<AddOutlined />}
            dsVersion="2.0"
            type="outlined"
            variant="neutral"
            _legacy_variant="outlined-subtle"
            isDisabled={isUploading}
            testId="worksheet-mediaUploadButton-addFiles"
          >
            {t("common:add_with_label", {
              label: t("common:file_other"),
            })}
          </Button>
        }
        buttonDropDownContainerStyle={style.createDropDownContainerStyle}
        addAttachment={attachments =>
          onCreateAttachment({
            attachments,
          })
        }
      />
    </div>
  );
});

const mapStateToProps = state => {
  const progressOfUploads = _.get(state, "app_services.progressOfUploads");
  const questionAttachments = _.pickBy(progressOfUploads, attachment =>
    _.includes(
      ["QUESTION_ATTACHMENT", "QUESTION_SUBMISSION_ATTACHMENT"],
      attachment.parentType
    )
  );
  const url = new URL(window.location.href);
  const isWorksheetWebView = url?.searchParams?.get("isWorksheetWebView");

  const isUploading = !_.isEmpty(questionAttachments);
  return {
    isUploading,
    isWorksheetWebView,
  };
};

const mapActionCreators = {
  createAttachment,
};

MediaUploadButton.displayName = "MediaUploadButton";

export default connect(mapStateToProps, mapActionCreators)(MediaUploadButton);
